<div
  class="rich-text-wrapper"
  [ngClass]="styleClass"
  [innerHTML]="content | markdownToSafeHtml"
></div>
